//获取图片地址
let imgUrl;
let baseUrl;
let debugMode=true;
if (process.env.NODE_ENV == 'production') {
	/**
	 * test
	 * baseUrl = 'http://8.137.8.158:8099/chat-api'
	imgUrl = 'http://8.137.8.158:8099'
	debugMode=false;
	 */
	
	/**  product
	  baseUrl = 'https://www.feilubino.online/chat-api'
	  debugMode=false;
	 */
   baseUrl = 'https://customer.threebx123.store/chat-api'
  	  debugMode=false;
}else{
	//调试环境
    baseUrl = 'http://127.0.0.1:8099/chat-api'
	imgUrl = 'http://127.0.0.1:8099'
	debugMode=true;
	
	baseUrl = 'http://8.137.8.158:8099/chat-api'
	imgUrl = 'http://8.137.8.158:8099'
	debugMode=true;
	  baseUrl = 'https://www.feilubino.online/chat-api'
//	  baseUrl = 'http://127.0.0.1:8099/chat-api'
//	imgUrl = 'http://127.0.0.1:8099'
//	debugMode=true;
}
console.log(baseUrl);

export {
	baseUrl,
    imgUrl,
    debugMode
}
